import store from '@/store';

export default async function fetchClientToken(request) {
  try {
    const { currentDwollaCustomerId } = store.state.fundingSource;
    const payload = { ...request, dwollaCustomerId: currentDwollaCustomerId };
    const response = await store.dispatch('fundingSource/getClientToken', payload);
    return response;
  } catch (error) {
    console.error('Error fetching Dwolla client token:', error);
    throw error;
  }
}



// WEBPACK FOOTER //
// ./src/services/dwolla.js